<template>
  <div>
    <Banner type="shoppingcart" />
    <div class="page-container j-container-box-shadow container">
      <div class="title">
        <span
          @click="handleTabChange(1)"
          class="title-span"
          :class="{
            'title-selected j-title': tab === 1,
            'j-sub-title': tab !== 1
          }"
        >
          {{ $t('shopping_cart.part_title') }}
        </span>

        <a-divider type="vertical" style="height: 28px; margin: 0 50px;" />

        <span
          @click="handleTabChange(2)"
          class="title-span"
          :class="{
            'title-selected j-title': tab === 2,
            'j-sub-title': tab !== 2
          }"
        >
          {{ $t('shopping_cart.vehicle_title') }}
        </span>
      </div>

      <a-divider style="margin-top: 0;" />

      <div v-show="tab === 1">
        <PartCart :consigneeDropdownList="consigneeDropdownList" />
      </div>
      <div v-show="tab === 2">
        <VehicleCart :consigneeDropdownList="consigneeDropdownList" />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { mapState } from 'vuex';
import Banner from '@/components/banner/Banner.vue';
import VehicleCart from './VehicleCart.vue';
import PartCart from './PartCart.vue';
import { getAllCustomerCompany } from '@/api/apis';

export default defineComponent({
  name: 'ShoppingCart',
  components: {
    Banner,
    VehicleCart,
    PartCart
  },
  data() {
    return {
      consigneeDropdownList: [],
      tab: 1
    };
  },
  created() {
    this.loadConsignee();
  },
  computed: {
    ...mapState(['userInfo'])
  },
  methods: {
    async loadConsignee() {
      const res = await getAllCustomerCompany({
        customerId: this.userInfo.id
      });

      if (res && res.success) {
        this.consigneeDropdownList = res.result || [];
      }
    },
    handleTabChange(tab) {
      this.tab = tab;

      this.$router.push(`/shoppingcart?tab=${this.tab}`);
    }
  },
  watch: {
    $route: {
      immediate: true,
      handler(val) {
        if (val.name === 'ShoppingCart') {
          const tab = +val.query.tab;
          if (tab && !isNaN(tab) && [1, 2].includes(tab)) {
            this.tab = tab;
          } else {
            this.$router.push(`/shoppingcart?tab=${this.tab}`);
          }
        }
      }
    }
  }
});
</script>

<style lang="scss" scoped>
.container {
  padding: 0 49px;
  background-color: white;

  .title {
    display: flex;
    align-items: center;
    height: 108px;

    .title-span {
      position: relative;
      cursor: pointer;
      padding: 32px 0 29px 0;
      &:not(.title-selected) {
        color: $primary-secondary-forecolor;
        font-weight: bold;
      }

      &.title-selected {
        transition: all 0.5s;
        &::after {
          display: block;
          content: '';
          width: 100%;
          height: 4px;
          background: $primary-color;
          bottom: 0;
          position: absolute;
        }
      }
    }
  }
}
</style>
